import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ChevronLeftIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M15 6C15 6 9.00001 10.4189 9 12C8.99999 13.5812 15 18 15 18" stroke="currentColor" />
    </SvgIcon>
  )
}
